// extracted by mini-css-extract-plugin
export default {"tag":"Ca12Kj","root":"FIyIqA","tagsLabel":"mEcrVk","list":"TDWSOI"};